import { gql } from "@apollo/client";

// Vertical Sales Report — vendor-scoped statement of what one vendor delivered for an event.
// Same Hasura views as Vendor Payouts; we just slice harder by vendor and aggregate at the
// report level instead of by-day/by-location.

export const GET_FINANCIAL_DAILY = gql`
  query vertical_sales_financial($where: reports_financial_bool_exp) {
    reports_financial(where: $where, order_by: { transaction_date: asc }) {
      vendor_id
      vendor_name
      event_id
      event_name
      transaction_date
      total_gross_sales
      gross_credit_sales
      gross_rfid_sales
      gross_cash_balance_sales
      gross_cash_sales
      gross_token_sales
      gross_promo_balance_sales
      total_tax
      total_tips
      total_discounts
      total_promo_discounts
      total_refunds
      total_transaction_count
    }
  }
`;

export const GET_PRODUCT_MIX = gql`
  query vertical_sales_product_mix($where: reports_product_mix_bool_exp) {
    reports_product_mix(where: $where, order_by: { pos_name: asc }) {
      pos_name
      description
      product_type
      vendor_id
      vendor_name
      total_units_sold
      credit_units_sold
      rfid_units_sold
      cash_balance_units_sold
      gross_credit_sales
      gross_rfid_sales
      gross_cash_balance_sales
      total_gross_sales
      total_tax
      total_discounts
    }
  }
`;

export const GET_EVENT = gql`
  query vertical_sales_event($id: Int!) {
    events_by_pk(id: $id) {
      id
      name
      start_date
      end_date
      organization {
        id
        name
        logo_url
      }
    }
  }
`;

// Pulled from reports_transactions for client-side card-brand aggregation.
// Bounded scope (single vendor + single event) keeps the payload small.
export const GET_CARD_BRANDS = gql`
  query vertical_sales_card_brands($where: reports_transactions_bool_exp!) {
    reports_transactions(where: $where, limit: 10000) {
      card_type
      transaction_amount
      payment_type
    }
  }
`;

export const GET_VENDOR = gql`
  query vertical_sales_vendor($id: Int!) {
    vendors_by_pk(id: $id) {
      id
      name
      revenue_share
      flat_fee
    }
  }
`;
